var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main-footer"},[_c('div',{staticClass:"pull-right hidden-xs"},[_c('b',[_vm._v("Version")]),_vm._v(" 1.0\n  ")]),_vm._v(" "),_c('strong',[_vm._v("Copyright © 2014-2018 "),_c('a',{attrs:{"target":"_blank","href":"http://www.phoenixbioinformatics.org"}},[_vm._v("Phoenix Bioinformatics")]),_vm._v(".")]),_vm._v(" All rights\n  reserved.\n")])
}]

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/Footer.vue